export default "__VITE_ASSET__Bq51zgJy__"